import { defineStore as F, waitForPinia as S, initStore as Y } from "@gitcoffee/store";
import { waitForPinia as De } from "@gitcoffee/store";
import { storage as P, getItem as M, setItem as L, configureStorage as N } from "@gitcoffee/storage";
import { ref as _, reactive as v, watch as T, createApp as O } from "vue";
import { defaultBaseSettingData as U, syncSet as z, syncGet as R } from "@gitcoffee/core";
import { ConfigProvider as u, message as j, Modal as H } from "ant-design-vue";
import { getCurrentLanguage as q, initI18n as B } from "@gitcoffee/i18n";
import { configureAuth as K, authManager as V } from "@gitcoffee/auth";
import { initApiClient as Q } from "@gitcoffee/api";
import { initPluginSystem as J } from "@gitcoffee/plugins";
const p = {
  // 从 @gitcoffee/core 继承基础设置
  ...U,
  // 搜索设置（app 包扩展的特定设置）
  smartSearchEnabled: null,
  // 不设置默认值，以config.ts中的配置为准
  aiModeSearch: null
  // 不设置默认值，以config.ts中的配置为准
}, W = () => {
  try {
    const e = { ...p }, t = R("appSettings");
    if (t)
      try {
        const a = JSON.parse(t), r = {
          ...e,
          ...a
        };
        return r.smartSearchEnabled = null, r.aiModeSearch = null, r;
      } catch (a) {
        console.error("Failed to parse unified settings:", a);
      }
    return e;
  } catch (e) {
    return console.error("Failed to load settings from storage:", e), p;
  }
}, k = async () => {
  try {
    const e = await P.get("appSettings");
    if (e) {
      if (e.activeCollapseKeys) {
        const t = e.activeCollapseKeys || [];
        Array.isArray(t) && (e.activeCollapseKeys = t);
      }
      e.smartSearchEnabled = null, e.aiModeSearch = null, e.smartSearchEnabled !== !1 ? e.showSearchEngineSelector = !1 : e.showSearchEngineSelector = !0, n.value = e;
      return;
    }
  } catch (e) {
    console.error("Failed to load settings from async storage:", e), n.value.smartSearchEnabled = null, n.value.aiModeSearch = null, n.value.smartSearchEnabled !== !1 ? n.value.showSearchEngineSelector = !1 : n.value.showSearchEngineSelector = !0;
  }
}, G = W(), n = _(v(G)), Se = () => n, w = () => {
  try {
    z("appSettings", JSON.stringify(n.value)), (async () => {
      try {
        await P.set("appSettings", n.value);
      } catch (e) {
        console.error("Failed to save settings to async storage:", e);
      }
    })();
  } catch (e) {
    console.error("Failed to save settings to storage:", e);
  }
}, $e = (e) => {
  n.value = { ...n.value, ...e }, w();
}, ye = () => {
  n.value = v({ ...p }), w();
};
T(
  () => n.value,
  (e) => {
    w();
  },
  { deep: !0 }
);
const C = {
  name: "AI Bot",
  logoUrl: "",
  version: "1.0.0",
  officialWebsite: ""
}, $ = _({ ...C }), be = (e) => {
  $.value = { ...$.value, ...e };
}, ve = (e) => {
  $.value = { ...e };
}, we = F("app", {
  state: () => ({
    // 应用信息
    appInfo: { ...C },
    // 设置相关状态
    settingData: p,
    // 加载状态
    isLoading: !1
  }),
  getters: {
    // 计算属性：当前主题
    currentTheme: (e) => e.settingData.theme,
    // 计算属性：当前语言
    currentLanguage: (e) => e.settingData.language
  },
  actions: {
    // 设置应用信息
    updateAppInfo(e) {
      this.appInfo = { ...this.appInfo, ...e };
    },
    // 设置设置数据
    updateSettingData(e) {
      this.settingData = { ...this.settingData, ...e };
    },
    // 更新主题
    updateTheme(e) {
      this.settingData.theme = e;
    },
    // 更新语言
    updateLanguage(e) {
      this.settingData.language = e;
    },
    // 初始化设置
    async initialize() {
      this.isLoading = !0;
      try {
        await this.loadSettingsFromStorage();
      } catch (e) {
        console.error("Failed to initialize app settings:", e);
      } finally {
        this.isLoading = !1;
      }
    },
    // 保存设置到存储
    async saveSettingsToStorage() {
      try {
        await L("appSettings", JSON.stringify(this.settingData));
      } catch (e) {
        console.error("Failed to save settings to storage:", e);
      }
    },
    // 从存储加载设置
    async loadSettingsFromStorage() {
      try {
        const e = await M("appSettings");
        e && (this.settingData = { ...this.settingData, ...JSON.parse(e) });
      } catch (e) {
        console.error("Failed to load settings from storage:", e);
      }
    }
  }
}), X = () => {
  let e = !1;
  try {
    if (typeof window < "u" && window.localStorage) {
      const t = "__privacy_mode_test__", a = "test";
      window.localStorage.setItem(t, a);
      const r = window.localStorage.getItem(t);
      window.localStorage.removeItem(t), r !== a && (e = !0);
    }
  } catch {
    e = !0;
  }
  try {
    if (typeof window < "u" && window.sessionStorage) {
      const t = "__privacy_mode_test__", a = "test";
      window.sessionStorage.setItem(t, a);
      const r = window.sessionStorage.getItem(t);
      window.sessionStorage.removeItem(t), r !== a && (e = !0);
    }
  } catch {
    e = !0;
  }
  try {
    if (typeof window < "u" && window.indexedDB) {
      const t = window.indexedDB.open("__privacy_mode_test__");
      t.onerror = () => {
      };
    }
  } catch {
    e = !0;
  }
  return e;
}, Z = () => typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme)").media !== "not all" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1, ee = () => {
  if (X())
    return !0;
  try {
    if (typeof window < "u" && window.localStorage) {
      const e = window.localStorage.getItem("theme");
      if (e === "dark" || e === "light")
        return e === "dark";
    }
  } catch (e) {
    console.warn("Failed to read browser theme from localStorage:", e);
  }
  return Z();
};
function xe(e) {
  const t = v({
    algorithm: u.defaultAlgorithm
  }), a = () => {
    try {
      if (e)
        try {
          const o = e.getAppSettings?.theme;
          if (o)
            return o;
        } catch (o) {
          console.warn("Error getting theme from settingsStore, falling back to settingData:", o);
        }
      return n.value.theme || "light";
    } catch (o) {
      return console.error("Error getting current theme:", o), "light";
    }
  }, r = () => {
    const o = a();
    if (o === "auto")
      try {
        return ee();
      } catch (s) {
        return console.warn("Error detecting theme, falling back to light:", s), !1;
      }
    return o === "dark";
  }, d = () => {
    try {
      const o = a(), s = r();
      if (t.algorithm = s ? u.darkAlgorithm : u.defaultAlgorithm, typeof document < "u" && document.documentElement) {
        const g = document.documentElement;
        s ? g.classList.add("dark") : g.classList.remove("dark");
      } else
        console.warn("document.documentElement not available, skipping theme class update");
    } catch (o) {
      console.error("Error setting theme:", o);
      try {
        typeof document < "u" && document.documentElement && document.documentElement.classList.remove("dark"), t.algorithm = u.defaultAlgorithm;
      } catch (s) {
        console.warn("Error in theme fallback:", s);
      }
    }
  }, f = () => {
    try {
      if (typeof window > "u" || !window.matchMedia)
        return;
      const o = window.matchMedia("(prefers-color-scheme: dark)"), s = () => {
        try {
          a() === "auto" && d();
        } catch (g) {
          console.error("Error handling theme change:", g);
        }
      };
      return o.addEventListener("change", s), () => {
        try {
          o.removeEventListener("change", s);
        } catch (g) {
          console.error("Error removing theme change listener:", g);
        }
      };
    } catch (o) {
      return console.error("Error setting up theme listener:", o), () => {
      };
    }
  };
  try {
    d();
  } catch (o) {
    console.error("Error initializing theme:", o);
  }
  return {
    themeConfig: t,
    setTheme: d,
    setupThemeListener: f,
    getCurrentTheme: a
  };
}
const te = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages"
};
function m() {
  return m = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var r in a) ({}).hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
    return e;
  }, m.apply(null, arguments);
}
const ae = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, A = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, x = {
  lang: m({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, ae),
  timePickerLocale: m({}, A)
}, l = "${label} is not a valid ${type}", D = {
  locale: "en",
  Pagination: te,
  DatePicker: x,
  TimePicker: A,
  Calendar: x,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: l,
        method: l,
        array: l,
        object: l,
        number: l,
        date: l,
        boolean: l,
        integer: l,
        float: l,
        regexp: l,
        email: l,
        url: l,
        hex: l
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  }
}, re = {
  // Options.jsx
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination.jsx
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页"
}, oe = {
  locale: "zh_CN",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "确定",
  timeSelect: "选择时间",
  dateSelect: "选择日期",
  weekSelect: "选择周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上个月 (翻页上键)",
  nextMonth: "下个月 (翻页下键)",
  monthSelect: "选择月份",
  yearSelect: "选择年份",
  decadeSelect: "选择年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
  previousYear: "上一年 (Control键加左方向键)",
  nextYear: "下一年 (Control键加右方向键)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世纪",
  nextCentury: "下一世纪"
}, E = {
  placeholder: "请选择时间",
  rangePlaceholder: ["开始时间", "结束时间"]
}, y = {
  lang: m({
    placeholder: "请选择日期",
    yearPlaceholder: "请选择年份",
    quarterPlaceholder: "请选择季度",
    monthPlaceholder: "请选择月份",
    weekPlaceholder: "请选择周",
    rangePlaceholder: ["开始日期", "结束日期"],
    rangeYearPlaceholder: ["开始年份", "结束年份"],
    rangeMonthPlaceholder: ["开始月份", "结束月份"],
    rangeQuarterPlaceholder: ["开始季度", "结束季度"],
    rangeWeekPlaceholder: ["开始周", "结束周"]
  }, oe),
  timePickerLocale: m({}, E)
};
y.lang.ok = "确定";
const i = "${label}不是一个有效的${type}", h = {
  locale: "zh-cn",
  Pagination: re,
  DatePicker: y,
  TimePicker: E,
  Calendar: y,
  // locales for all components
  global: {
    placeholder: "请选择"
  },
  Table: {
    filterTitle: "筛选",
    filterConfirm: "确定",
    filterReset: "重置",
    filterEmptyText: "无筛选项",
    filterCheckall: "全选",
    filterSearchPlaceholder: "在筛选项中搜索",
    selectAll: "全选当页",
    selectInvert: "反选当页",
    selectNone: "清空所有",
    selectionAll: "全选所有",
    sortTitle: "排序",
    expand: "展开行",
    collapse: "关闭行",
    triggerDesc: "点击降序",
    triggerAsc: "点击升序",
    cancelSort: "取消排序"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "结束导览"
  },
  Modal: {
    okText: "确定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Popconfirm: {
    cancelText: "取消",
    okText: "确定"
  },
  Transfer: {
    searchPlaceholder: "请输入搜索内容",
    itemUnit: "项",
    itemsUnit: "项",
    remove: "删除",
    selectCurrent: "全选当页",
    removeCurrent: "删除当页",
    selectAll: "全选所有",
    removeAll: "删除全部",
    selectInvert: "反选当页"
  },
  Upload: {
    uploading: "文件上传中",
    removeFile: "删除文件",
    uploadError: "上传错误",
    previewFile: "预览文件",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "暂无数据"
  },
  Icon: {
    icon: "图标"
  },
  Text: {
    edit: "编辑",
    copy: "复制",
    copied: "复制成功",
    expand: "展开"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可选）",
    defaultValidateMessages: {
      default: "字段验证错误${label}",
      required: "请输入${label}",
      enum: "${label}必须是其中一个[${enum}]",
      whitespace: "${label}不能为空字符",
      date: {
        format: "${label}日期格式无效",
        parse: "${label}不能转换为日期",
        invalid: "${label}是一个无效日期"
      },
      types: {
        string: i,
        method: i,
        array: i,
        object: i,
        number: i,
        date: i,
        boolean: i,
        integer: i,
        float: i,
        regexp: i,
        email: i,
        url: i,
        hex: i
      },
      string: {
        len: "${label}须为${len}个字符",
        min: "${label}最少${min}个字符",
        max: "${label}最多${max}个字符",
        range: "${label}须在${min}-${max}字符之间"
      },
      number: {
        len: "${label}必须等于${len}",
        min: "${label}最小值为${min}",
        max: "${label}最大值为${max}",
        range: "${label}须在${min}-${max}之间"
      },
      array: {
        len: "须为${len}个${label}",
        min: "最少${min}个${label}",
        max: "最多${max}个${label}",
        range: "${label}数量须在${min}-${max}之间"
      },
      pattern: {
        mismatch: "${label}与模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "预览"
  },
  QRCode: {
    expired: "二维码已过期",
    refresh: "点击刷新",
    scanned: "已扫描"
  }
}, ne = {
  // Options.jsx
  items_per_page: "條/頁",
  jump_to: "跳至",
  jump_to_confirm: "確定",
  page: "頁",
  // Pagination.jsx
  prev_page: "上一頁",
  next_page: "下一頁",
  prev_5: "向前 5 頁",
  next_5: "向後 5 頁",
  prev_3: "向前 3 頁",
  next_3: "向後 3 頁"
}, le = {
  locale: "zh_TW",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "確定",
  timeSelect: "選擇時間",
  dateSelect: "選擇日期",
  weekSelect: "選擇周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上個月 (翻頁上鍵)",
  nextMonth: "下個月 (翻頁下鍵)",
  monthSelect: "選擇月份",
  yearSelect: "選擇年份",
  decadeSelect: "選擇年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH時mm分ss秒",
  previousYear: "上一年 (Control鍵加左方向鍵)",
  nextYear: "下一年 (Control鍵加右方向鍵)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世紀",
  nextCentury: "下一世紀"
}, I = {
  placeholder: "請選擇時間"
}, b = {
  lang: m({
    placeholder: "請選擇日期",
    yearPlaceholder: "請選擇年份",
    quarterPlaceholder: "請選擇季度",
    monthPlaceholder: "請選擇月份",
    weekPlaceholder: "請選擇周",
    rangePlaceholder: ["開始日期", "結束日期"],
    rangeYearPlaceholder: ["開始年份", "結束年份"],
    rangeMonthPlaceholder: ["開始月份", "結束月份"],
    rangeQuarterPlaceholder: ["開始季度", "結束季度"],
    rangeWeekPlaceholder: ["開始周", "結束周"]
  }, le),
  timePickerLocale: m({}, I)
};
b.lang.ok = "確 定";
const c = "${label}不是一個有效的${type}", ie = {
  locale: "zh-tw",
  Pagination: ne,
  DatePicker: b,
  TimePicker: I,
  Calendar: b,
  global: {
    placeholder: "請選擇"
  },
  Table: {
    filterTitle: "篩選器",
    filterConfirm: "確定",
    filterReset: "重置",
    filterEmptyText: "無篩選項",
    selectAll: "全部選取",
    selectInvert: "反向選取",
    selectNone: "清空所有",
    selectionAll: "全選所有",
    sortTitle: "排序",
    expand: "展開行",
    collapse: "關閉行",
    triggerDesc: "點擊降序",
    triggerAsc: "點擊升序",
    cancelSort: "取消排序"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "結束導覽"
  },
  Modal: {
    okText: "確定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Popconfirm: {
    okText: "確定",
    cancelText: "取消"
  },
  Transfer: {
    searchPlaceholder: "搜尋資料",
    itemUnit: "項目",
    itemsUnit: "項目",
    remove: "删除",
    selectCurrent: "全選當頁",
    removeCurrent: "删除當頁",
    selectAll: "全選所有",
    removeAll: "删除全部",
    selectInvert: "反選當頁"
  },
  Upload: {
    uploading: "正在上傳...",
    removeFile: "刪除檔案",
    uploadError: "上傳失敗",
    previewFile: "檔案預覽",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "無此資料"
  },
  Icon: {
    icon: "圖標"
  },
  Text: {
    edit: "編輯",
    copy: "複製",
    copied: "複製成功",
    expand: "展開"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可選）",
    defaultValidateMessages: {
      default: "字段驗證錯誤${label}",
      required: "請輸入${label}",
      enum: "${label}必須是其中一個[${enum}]",
      whitespace: "${label}不能為空字符",
      date: {
        format: "${label}日期格式無效",
        parse: "${label}不能轉換為日期",
        invalid: "${label}是一個無效日期"
      },
      types: {
        string: c,
        method: c,
        array: c,
        object: c,
        number: c,
        date: c,
        boolean: c,
        integer: c,
        float: c,
        regexp: c,
        email: c,
        url: c,
        hex: c
      },
      string: {
        len: "${label}須為${len}個字符",
        min: "${label}最少${min}個字符",
        max: "${label}最多${max}個字符",
        range: "${label}須在${min}-${max}字符之間"
      },
      number: {
        len: "${label}必須等於${len}",
        min: "${label}最小值為${min}",
        max: "${label}最大值為${max}",
        range: "${label}須在${min}-${max}之間"
      },
      array: {
        len: "須為${len}個${label}",
        min: "最少${min}個${label}",
        max: "最多${max}個${label}",
        range: "${label}數量須在${min}-${max}之間"
      },
      pattern: {
        mismatch: "${label}與模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "預覽"
  },
  QRCode: {
    expired: "二維碼過期",
    refresh: "點擊刷新",
    scanned: "已掃描"
  }
};
function Pe() {
  const e = {
    en: D,
    zh: h,
    "zh-TW": ie
    // 后续添加新语言只需在这里添加配置
    // 例如：
    // ja: jaJP
  };
  return {
    antdLocale: e[q()] || h,
    antdLocaleMap: e
  };
}
function _e(e) {
  const t = async () => {
    try {
      const a = e?.smartSearchDefault !== void 0 ? e.smartSearchDefault : !0, r = e?.aiModeSearchDefault !== void 0 ? e.aiModeSearchDefault : !0;
      await k(), n.value.smartSearchEnabled = a, window.__GLOBAL_SMART_SEARCH_DEFAULT__ = a, a ? n.value.showSearchEngineSelector = !1 : n.value.showSearchEngineSelector = !0, n.value.aiModeSearch = r, window.__GLOBAL_AI_MODE_SEARCH_DEFAULT__ = r, e?.onInitialized && e.onInitialized();
    } catch (a) {
      console.error("Failed to initialize app:", a);
    }
  };
  return t(), {
    isInitialized: !0,
    // 直接返回true，避免使用ref
    initializeApp: t
  };
}
function Te(e) {
  return T(
    n,
    async (t, a) => {
      JSON.stringify(t) !== JSON.stringify(a) && e.isInitialized.value && (await S(), (typeof e.settingsStore == "function" ? e.settingsStore() : e.settingsStore).getIsLoggedIn || Object.assign(n.value, a));
    },
    { deep: !0 }
  ), {
    // 可以添加其他登录相关的功能
  };
}
async function ke(e) {
  N(e.APP_ID);
  const t = e.app || O(e.App);
  t.use(e.router), t.config.globalProperties.$message = j;
  const a = {
    en: D,
    zh: h
  };
  e.app || await Y(t), e.registerComponents(t);
  const r = await B();
  console.log("[initApp] Configuring auth..."), K({
    loginConfirmHandler: async () => (console.log("[initApp] loginConfirmHandler called"), new Promise((o) => {
      H.confirm({
        title: r.global.t("common.login.prompt"),
        content: r.global.t("common.login.confirm"),
        onOk: async () => {
          await S(), e.useSettingsStore().login(), o(!1);
        },
        onCancel() {
          o(!1);
        }
      });
    }))
  }), console.log("[initApp] Auth configured"), t.use(u, {
    locale: a[r.global.locale.value] || h
    // 不在这里设置主题算法，让 App.vue 中的组件级配置生效
  }), t.use(r), e.app || t.mount("#app"), await S();
  const d = e.useSettingsStore();
  await d.initialize();
  const f = d.getIsLoggedIn || d.isLoggedIn;
  V.setUserInfo(f ? d.userInfo : null), await J({ storagePrefix: `${e.APP_ID}_plugin-manager-` }), Q({
    baseUrl: e.BASE_URL,
    headers: {
      "App-Id": e.APP_ID
    }
  }), await k();
}
export {
  $ as appInfo,
  Se as createSettingData,
  C as defaultAppInfo,
  p as defaultSettingData,
  ke as initApp,
  k as loadSettingsFromAsyncStorage,
  ye as resetSettings,
  w as saveSettingsToStorage,
  ve as setAppInfo,
  n as settingData,
  be as updateAppInfo,
  $e as updateSettings,
  Pe as useAntdLocale,
  _e as useAppInitialization,
  we as useAppStore,
  Te as useLoginGuard,
  xe as useTheme,
  De as waitForPinia
};
//# sourceMappingURL=index.mjs.map
